/* eslint-disable  import/no-unused-modules */
import withUniversalStore from "../../../../shared/seller-services/utilities/withUniversalStore";
import rootStoreInstance, {
  createRootStoreInstance
} from "../../stores/rootStoreInstance";
import HomeClaimContent from "./HomeClaimContent";

const ConnectedHomeClaimContent = withUniversalStore(
  rootStoreInstance,
  createRootStoreInstance
)(HomeClaimContent);

export { ConnectedHomeClaimContent as default, HomeClaimContent };
